import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { Account, PatientAccountStore } from '../auth-types'

export const usePatientAccountStore = create<PatientAccountStore>()(
  persist(
    set => ({
      account: {} as Account,
      setAccount: newData => {
        set(prevState => ({
          account: {
            ...prevState.account,
            ...newData,
          },
        }))
      },
      resetAccount: () => set({ account: {} as Account }),
    }),
    {
      name: '@ConexaPaciente:account',
      getStorage: () => sessionStorage,
    },
  ),
)
